import { useEffect } from 'react';

export const useSidebarRefresh = (refresh: () => void): void => {
  useEffect(() => {
    const onRefresh = () => refresh();
    window.addEventListener('sidebar-refresh', onRefresh);
    return () => window.removeEventListener('sidebar-refresh', onRefresh);
  }, [refresh]);
};
